<template>
    <div class='component-page'>
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                
                <Col span="2" style="float:right">
                <i-button type="primary" icon="md-add" shape="circle" @click="add_new">添加</i-button>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right' size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
            <Modal v-model="addModel" width="720" :title="modalTitle">
                <div v-if='addModel'>
                    <Form ref="formData" :model="formData" :rules="verificationRule" label-position="top">
                        <Row>
                            <Col span="11">
                                <FormItem label="类别名称" prop='name'>
                                    <Input v-model="formData.name" placeholder="请输入..."></Input>
                                </FormItem>
                            </Col>
                             <Col span="11">
                                <FormItem label="排序" prop='sort'>
                                    <Input v-model="formData.sort" placeholder="请输入..."></Input>
                                </FormItem>
                            </Col>
                           
                        </Row>
                        <Row v-if='addModel'>
                            <FormItem label="封面图" prop="cover">
                                <UploadImg @getPicList="getPicList" :getList='formData.cover' message='1' id='img'></UploadImg>
                            </FormItem>
                        </Row>
                    </Form>
                </div>
                <div slot="footer">
                    <Button type='primary' shape="circle" ghost @click='cancel'>取消</Button>
                    <Button type="primary" shape="circle" @click="save('formData')">确定</Button>
                </div>
            </Modal>
            <Modal v-model="remindModal" width="440" @on-cancel='cancel' class='remind'>
                <div class='remindContent'>
                    {{remindContent}}
                </div>
                <div slot="footer">
                    <Button type='primary' ghost shape="circle" @click='cancel'>取消</Button>
                    <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
                </div>
            </Modal>
        </div>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>


<script>
    import moment from 'moment'
    import {
        fetchTableList,
        setDel,
        setAdd,
        setUpdate,
        fetchInfo,
        setStatus
    } from '@/api/videoType'
    
    import UploadImg from '../common/picture.vue'

    
    export default {
        name: 'user-components',
        components: {
    
           UploadImg
        },
        data() {
            return {
                total_count: 0, //列表总条数
                formItem: {
                    page: 1, //列表当前页数
                    page_size: 10,
                  
                },
              
                type_id: '',
                modalTitle: '新增',
                remindModal: false,
                addModel: false, //添加老师
                formData: {
                    type_id: '',
                    name: '',
                    cover: '',
                    sort:'',
                },
              
                remindContent: '',
                verificationRule: {
                    name: [{
                        required: true,
                        message: '不能为空'
                    }],
                    sort: [{
                        required: true,
                        message: '不能为空'
                    }],
    
                }, //
                editIncellColumns: [{
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
    
                    },
                    {
                        title: '类别名称',
                        align: 'center',
                        key: 'name',
                    },

                    {
                        title: '状态',
                        align: 'center',
                        key: 'status',
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('div', '上架')
                            }else{
                                return h('div', '下架')

                            }
                        }
                    },
                    
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'create_at',
                        width:150,
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.status == 0) {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true
    
                                        },
                                        style: {
                                            marginRight: '10px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.type_id)
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            
                                            ghost: true,
    
                                        },
                                        style: {
                                            marginRight: '10px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.type_id)
                                            }
                                        }
                                    }, '删除'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true
    
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.type_id,'确认上架该视频类别吗？')
                                            }
                                        }
                                    }, '上架'),
                                ])
                            } else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true
    
                                        },
                                        style: {
                                            marginRight: '10px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.type_id)
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true,
                                         
                                        },
                                        style: {
                                            marginRight: '10px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.type_id)
                                            }
                                        }
                                    }, '删除'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
    
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.type_id,'确认下架该视频类别吗？')
                                            }
                                        }
                                    }, '下架'),
                                ])
                            }
    
                        }
                    },
    
                ], //列表标题
    
                editIncellData: [], //列表数据
    
            };
        },
        methods: {
            //获取列表数据
            getData() {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res = res.data;
                    this.$Loading.finish();
                    if (res.code == 200) {
                        this.editIncellData = res.data.lists;
                        this.total_count = parseInt(res.data.total_count);
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            //   this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
             // 添加
            add_new() {
                this.formData.type_id = '';
              
                this.formData.name = '';
            
                this.formData.cover = '';
   
                this.formData.sort = '';

                this.modalTitle = '新增';
                this.addModel = true;
            },
            // 修改
            edit(id) {
                fetchInfo({
                    type_id: id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.modalTitle = '修改';
                        this.formData = res.data;
                        this.addModel = true;
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            // 保存新增和修改
            save(name){
                this.$refs[name].validate(valid => {
                    if (valid) {
                        if(this.formData.type_id!=''){
                            setUpdate(this.formData).then(res => {
                                res = res.data;
                                if (res.code == 200) {
                                    this.getData();
                                    this.addModel=false;
                                } else if (res.code == 14001) {
                                    this.$Message.error(res.msg)
                                    this.$store.dispatch('handleLogOut').then(res => {
                                        this.$store.commit('clearOpenedSubmenu')
                                        this.$router.push({
                                        name: 'login'
                                        })
                                    })
                                } else {
                                    this.$Message.error(res.msg)
                                }
                            })
                        }else{
                            setAdd(this.formData).then(res => {
                                res = res.data;
                                if (res.code == 200) {
                                    this.getData();
                                    this.addModel=false;
                                } else if (res.code == 14001) {
                                    this.$Message.error(res.msg)
                                    this.$store.dispatch('handleLogOut').then(res => {
                                        this.$store.commit('clearOpenedSubmenu')
                                        this.$router.push({
                                        name: 'login'
                                        })
                                    })
                                } else {
                                    this.$Message.error(res.msg)
                                }
                            })
                        }
                        
                    
                    }
                })
            },
            changeStatus(id,info){
                this.type_id = id;
                this.remindContent = info;
                this.remindModal = true;
            },
            delete(id) {
                this.type_id = id;
                this.remindContent = '确定删除该视频类别吗？';
                this.remindModal = true;
            },
            primaryRemind() {
                 if(this.remindContent == '确定删除该视频类别吗？'){
                    setDel({
                        type_id: this.type_id
                    }).then(res => {
                        res = res.data;
                        if (res.code == 200) {
                            this.formItem.page = 1;
        
                            this.getData();
                            this.remindModal = false;
                        } else if (res.code == 14001) {
                            this.$Message.error(responese.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        } else {
                            this.$Message.error(res.msg);
                        }
                    })
                }else{
                    setStatus({
                        type_id: this.type_id
                    }).then(res => {
                        res = res.data;
                        if (res.code == 200) {
                            this.getData();
                            this.remindModal = false;
                        } else if (res.code == 14001) {
                            this.$Message.error(responese.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        } else {
                            this.$Message.error(res.msg);
                        }
                    })
                }
            },
            getPicList(picList) {
                this.formData.cover = picList[0].url.split('.com')[1];
            },
            cancel() {
                this.remindModal = false;
                this.addModel = false;
            },
            //搜索框搜索
            handleSearch() {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage(row) {
                this.formItem.page = row;
                this.getData();
            },
           
            //改变每页条数
            changePageSize(row) {
                this.formItem.page_size = row;
                this.formItem.page = 1;
                this.getData();
            }
    
        },
        mounted() {
            this.getData();
        },
    };
</script>
